import { createFileRoute } from '@tanstack/react-router'
import { Missions } from '@/features/missions'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/missions')({
  beforeLoad: requireAdmin,
  component: Missions,
})
